export default function (dsf,options) {
  return {
    id: "",
    name: "",
    code: "",
    type: dsf.metadata.mmtype(3),
    at: "",
    currentControl: null,
    controls: [],
    validate: dsf.metadata.validate(),
    defaultValue: null,
    isJSONString:true,
    valueAttributes: [
      {
        name: "图片",
        code: "img",
        type: dsf.metadata.getDataType("string"),
        length: 500,
        defaultValue: null,
        unit: null,
        encrypt:false
      },
      {
        name: "konva数据",
        code: "config",
        type: dsf.metadata.getDataType("longObject"),
        length: 1000,
        defaultValue: null,
        unit: null,
        encrypt:false
      },
    ],
  };
}
